var _defs, _g, _g2, _g3, _polygon, _polygon2, _polygon3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 460 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #e3ff00;\n      }\n\n      .cls-3 {\n        fill: #033047;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "160.04 112.11 185.47 112.11 185.47 156.91 160.04 172 160.04 112.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.97,112.61v44.02l-24.43,14.5v-58.52h24.43M185.97,111.61h-26.43v61.27l1.51-.9,24.43-14.5.49-.29v-45.59h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "191.89 78.19 217.32 78.19 217.32 138.03 191.89 153.12 191.89 78.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.82,78.69v59.06l-24.43,14.5v-73.56h24.43M217.82,77.69h-26.43v76.32l1.51-.9,24.43-14.5.49-.29v-60.63h0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "224.54 41.1 249.97 41.1 249.97 118.47 224.54 133.57 224.54 41.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.47,41.6v76.58l-24.43,14.5V41.6h24.43M250.47,40.6h-26.43v93.84l1.51-.9,24.43-14.5.49-.29V40.6h0Z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "207.65 133.09 207.65 87.23 201.65 87.23 201.65 136.6 207.65 133.09"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "240.02 114.14 240.02 49.31 234.03 49.31 234.03 117.65 240.02 114.14"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "175.27 152.18 175.27 119.76 169.28 119.76 169.28 155.68 175.27 152.18"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "157.54 179.99 267.14 114.77 263.04 107.87 300.77 100.31 276.11 129.85 272.07 123.06 176.46 179.99 157.54 179.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.48,101.08l-23.31,27.91-3.93-6.62-95.92,57.12h-16.97l108.47-64.55-3.99-6.72,35.65-7.14M302.07,99.55l-2.78.56-35.65,7.14-1.38.28.72,1.21,3.48,5.86-107.61,64.04-3.12,1.86h20.88l.24-.14,95.06-56.61,3.42,5.76.72,1.21.91-1.08,23.31-27.91,1.82-2.18h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.719536d2e37725ea5b1a8541c3d17eab.svg";
export { ForwardRef as ReactComponent };